import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'common/backend/endpoints'

async function sendEmail(id, email) {
    let endpoint = null
    if(email){
        endpoint = SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT + `/enviar-email/${id}?email=${email}`;
    } else {
        endpoint = SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT + `/enviar-email/${id}`;
    }
    const response = await axios.get(endpoint);
    return response.data;
}

export default sendEmail;
